import '../passwordReset.scss';
import '../../../sendOtp/sendOtp.scss';
import React from 'react';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Button, Alert, Col, Row } from 'reactstrap';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { IRootState } from 'app/shared/reducers';
import { handlePasswordResetInit, reset, generateCaptcha } from '../password-reset.reducer';
import { SUCCESS, ERROR } from 'app/config/constants';
import { Translate, translate, getUrlParameter, Storage } from 'react-jhipster';

export interface IPasswordResetInitProps extends StateProps, DispatchProps, RouteComponentProps<{ key: any }> {}

export interface IPasswordResetInitState {
  visible: boolean;
  color: string;
  message: string;
  redirectOtp: boolean;
  captcha: string;
}
export class PasswordResetInit extends React.Component<IPasswordResetInitProps, IPasswordResetInitState> {
  state: IPasswordResetInitState = {
    visible: false,
    color: 'info',
    message: '',
    redirectOtp: false,
    captcha: ''
  };

  componentDidMount() {
    // const urlCallback = getUrlParameter('urlCallback', this.props.location.search);
    // const clientId = getUrlParameter('clientId', this.props.location.search);
    // Storage.session.set('urlCallbackFromSP', urlCallback);
    // Storage.session.set('clientIdFromSP', clientId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.responseInit !== nextProps.responseInit) {
      const { responseInit } = nextProps;
      if (responseInit && responseInit.status === SUCCESS) {
        this.setState({
          redirectOtp: true
        });
      } else if (responseInit && responseInit.status) {
        this.setState({
          visible: true,
          color: 'danger',
          message: responseInit.message && responseInit.message !== ERROR ? responseInit.message : 'Lỗi!'
        });
      }
    }

    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      } else {
        this.props.generateCaptcha();
      }
    }
  }

  componentWillUnmount() {}

  componentWillMount() {
    this.props.generateCaptcha();
  }

  handleValidSubmit = (event, values) => {
    this.props.handlePasswordResetInit(values.identity.trim(), values.code.trim());
    event.preventDefault();
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  render() {
    const { redirectOtp } = this.state;

    if (redirectOtp) {
      return (
        <Redirect
          push
          to={{
            pathname: '/reset/sendOtp',
            state: {
              mobile: this.props.responseInit.mobile,
              id: this.props.responseInit.id,
              email: this.props.responseInit.email,
              fullName: this.props.responseInit.fullname
              //name: this.props.responseInit.name
            }
          }}
        />
      );
    }
    return (
      <div>
        <Row className="justify-content-center avfield-font">
          <Col className="box-otp">
            <Row className="text-title-reset ">
              <label className="font-weight-bold" style={{ marginBottom: '25px' }}>
                <Translate contentKey="reset.request.title">Reset your password</Translate>
              </label>
            </Row>
            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <AvForm onValidSubmit={this.handleValidSubmit}>
              <AvField
                name="identity"
                label="CMT/CCCD"
                placeholder={translate('global.form.cmt.placeholder')}
                autoFocus={true}
                type="number"
                validate={{
                  required: { value: true, errorMessage: translate('register.messages.validate.cmt/cccd.required') },
                  pattern: {
                    value: '^([0-9]{9}|[0-9]{12})+$',
                    errorMessage: translate('register.messages.validate.cmt/cccd.minlength')
                  }
                }}
              />
              {/* <AvField
                name="mobile"
                label={translate('global.form.mobile.label')}
                placeholder="Nhập số điện thoại xác thực"
                validate={{
                  required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                  number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
                  minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
                  maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
                }}
              /> */}
              <label>{translate('global.form.code.label')}</label>
              <Row style={{ flex: 1 }}>
                <Col style={{ flex: 0.5 }}>
                  <AvField
                    name="code"
                    // label={translate('global.form.code.label')}
                    label=""
                    placeholder={translate('global.form.code.placeholder')}
                    validate={{
                      required: { value: true, errorMessage: translate('global.messages.validate.code.required') }
                    }}
                  />
                </Col>

                <Col style={{ flex: 0.4 }}>
                  <img className="captcha" src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
                </Col>

                <Col style={{ flex: 0.1 }}>
                  <img
                    className="btn-refresh-captcha"
                    src={require('../../../../images/header/refresh.svg')}
                    onClick={this.invokeResetCaptcha}
                    alt=""
                  />
                </Col>
              </Row>
              <Button className="btn-register" type="submit" block>
                <Translate contentKey="reset.request.form.button">Reset password</Translate>
              </Button>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ passwordReset }: IRootState) => ({
  responseInit: passwordReset.responseInit,
  responseCap: passwordReset.responseCaptcha
});

const mapDispatchToProps = { handlePasswordResetInit, reset, generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetInit);
